import { render, staticRenderFns } from "./RFQDetailDialog.vue?vue&type=template&id=26715492&"
import script from "./RFQDetailDialog.vue?vue&type=script&lang=js&"
export * from "./RFQDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports